import { z } from 'zod'
import { createExpenseTemplateSchema } from './create-expense-template.schema'

export const updateExpenseTemplateSchema = createExpenseTemplateSchema.partial()

export type UpdateExpenseTemplateDto = z.infer<typeof updateExpenseTemplateSchema>
